import { useOutletContext } from "react-router-dom";
import { COLORS } from "../../../../assets/utils/enums/colors";
import { LabelText, LargeHeadline, LittleSubHeadline, LittleText, NotificationText } from "../../../../components/typography";
import { OnboardingButtons } from "../../../../components/ui/button";
import { OnboardingBodyBlock } from "../settings";
import { OnboardingBodyItemsBlock } from "./structure-step";
import styled from "styled-components";
import { onboardingPlanData, OnboardingPlanEnum } from "../../../../assets/utils/data/onboarding";
import doneIcon from '../../../../assets/images/icons/done-dark-icon.svg';

export default function PlanStep() {
    const { plan, setPlan } =
        useOutletContext<{ plan: string; setPlan: React.Dispatch<React.SetStateAction<OnboardingPlanEnum>> }>();
    return (
        <OnboardingBodyBlock className="align-items-start mt-2 pt-5" style={{width: "90%"}}>
            <LabelText>Оберіть план для вашої CRM</LabelText>
            <LittleText className="accent-color pt-2">Ви можете змінити або скасувати підписку в будь-який момент.</LittleText>
            <OnboardingBodyItemsBlock className="pt-3">
                {onboardingPlanData.map((item) => {
                    const isActive = plan === item.title as OnboardingPlanEnum;

                    return (
                        <PlanWrapper $active={isActive}>
                            {item.label && (
                                <PlanLabel>
                                    {item.label}
                                </PlanLabel>
                            )}

                            <PlanCard
                                $active={isActive}
                                onClick={() => setPlan(item.title as OnboardingPlanEnum)}
                            >
                                <span className="d-flex flex-column">
                                    <LittleSubHeadline>{item.title}</LittleSubHeadline>
                                    <LittleText>{item.description}</LittleText>

                                    <span className="d-flex align-items-end gap-1 pt-2">
                                        <LargeHeadline>
                                            {item.price} {item.currency.symbol}
                                        </LargeHeadline>
                                        <LabelText>/ {item.time}</LabelText>
                                    </span>
                                </span>

                                <span className="d-flex flex-column gap-3">
                                    {item.items.map((text, index) => (
                                        <span key={index} className="d-flex align-items-start gap-2">
                                            <img src={doneIcon} alt="done-icon" />
                                            <NotificationText>{text}</NotificationText>
                                        </span>
                                    ))}
                                </span>
                            </PlanCard>
                        </PlanWrapper>
                    );
                })}

            </OnboardingBodyItemsBlock>
            <NotificationText className="disclaimer-text">Без прихованих платежів. Скасування в один клік</NotificationText>
            <OnboardingButtons isBackBtn={true} state={!plan} path="/onboarding/finish" />
        </OnboardingBodyBlock>
    )
}

const PlanLabel = styled(NotificationText)`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 60px;
  width: 100%;
  
  opacity: 0;
  display: flex;
  align-items: start;
  justify-content: center;
  padding-top: 12px;

  background-color: ${COLORS.blue};
  color: ${COLORS.white};

  border-radius: 16px 16px 0 0;
  pointer-events: none;

`;


const PlanCard = styled.div<{ $active: boolean }>`
  position: relative;
  z-index: 2;

  padding: 24px;
  background-color: ${COLORS.white};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  height: 100%;

  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  transform: ${({ $active }) =>
        $active ? "translateY(-4px)" : "none"};
${({ $active }) =>
        $active &&
        `transform: translateY(-4px);
        ${PlanLabel} {
            opacity: 1 !important;
            transform: translate(-50%, 0);
        }
    `}
  /* &:hover {
        transform: translateY(-8px);
        ${PlanLabel} {
            opacity: 1;
            transform: translate(-50%, 0);
        }
    } */

    
    
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);

  ${LittleSubHeadline}, 
  ${LargeHeadline}, 
  ${LabelText} {
    color: ${COLORS.secondary1};
  }

  ${LargeHeadline} {
    padding-bottom: 0;
    font-size: 36px;
    font-weight: 550;
  }

  ${NotificationText}, 
  ${LittleText} {
    color: ${COLORS["bg-text-color"]};
  }
`;

const PlanWrapper = styled.div<{ $active: boolean }>`
  position: relative;
  flex: 0 0 24.3%;
  padding-top: 38px; 
  border-radius: 16px;
  background-color: ${({ $active }) =>
        $active ? COLORS.blue : "transparent"};
  transition: background-color 0.25s ease;

  &:hover {
    background-color: ${COLORS.blue};

    ${PlanLabel} {
      opacity: 1;
    }
  }
  
  ${PlanLabel} {
    opacity: ${({ $active }) => ($active ? 1 : 0)};
    transform: translate(-50%, 0);
    padding-top: ${({ $active }) => ($active ? "8px" : "12px")};
    transition:
    opacity 0.25s ease-in,
    padding-top 0.25s ease,
    transform 0.25s ease;
  }
`;
